/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mode_CapitalsInputs */

const bn_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রাজধানী`)
};

const de_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptstädte`)
};

const el_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κεφάλαια`)
};

const en_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capitals`)
};

const es_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capitales`)
};

const fr_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capitales`)
};

const hi_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`राजधानियों`)
};

const hu_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tőkék`)
};

const id_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ibukota`)
};

const it_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capitali`)
};

const ja_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首都`)
};

const ko_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수도`)
};

const nl_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoofdsteden`)
};

const pl_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stolice`)
};

const pt_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capitais`)
};

const ru_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Столицы`)
};

const sv_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`versaler`)
};

const tr_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başkentler`)
};

const uk_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Столиці`)
};

const vi_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thủ đô`)
};

const zh_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首都`)
};

const zh_hant_mode_capitals = /** @type {(inputs: Mode_CapitalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首都`)
};

/**
* | output |
* | --- |
* | "Capitals" |
*
* @param {Mode_CapitalsInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const mode_capitals = /** @type {((inputs?: Mode_CapitalsInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mode_CapitalsInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_mode_capitals(inputs)
	if (locale === "de") return de_mode_capitals(inputs)
	if (locale === "el") return el_mode_capitals(inputs)
	if (locale === "en") return en_mode_capitals(inputs)
	if (locale === "es") return es_mode_capitals(inputs)
	if (locale === "fr") return fr_mode_capitals(inputs)
	if (locale === "hi") return hi_mode_capitals(inputs)
	if (locale === "hu") return hu_mode_capitals(inputs)
	if (locale === "id") return id_mode_capitals(inputs)
	if (locale === "it") return it_mode_capitals(inputs)
	if (locale === "ja") return ja_mode_capitals(inputs)
	if (locale === "ko") return ko_mode_capitals(inputs)
	if (locale === "nl") return nl_mode_capitals(inputs)
	if (locale === "pl") return pl_mode_capitals(inputs)
	if (locale === "pt") return pt_mode_capitals(inputs)
	if (locale === "ru") return ru_mode_capitals(inputs)
	if (locale === "sv") return sv_mode_capitals(inputs)
	if (locale === "tr") return tr_mode_capitals(inputs)
	if (locale === "uk") return uk_mode_capitals(inputs)
	if (locale === "vi") return vi_mode_capitals(inputs)
	if (locale === "zh") return zh_mode_capitals(inputs)
	return zh_hant_mode_capitals(inputs)
});